


export const trans_1=[
  {
    id:1,
    english:'a. Where are you from?',
    vietnamese:'Bạn đến từ đâu?',
    user_message:''
  },
  {
    id:2,
    english:'- Im from Vietnam',
    vietnamese:'Tôi đến từ Việt Name',
    user_message:''
  },
  {
    id:3,
    english:'b. What is your name?',
    vietnamese:'Tên bạn là gì?',
    user_message:''
  },
  {
    id:4,
    english:'- My name is Lan',
    vietnamese:'Tôi tên là Lần',
    user_message:''
  },
  {
    id:5,
    english:'My sisters name is Hoa, my brother is name is Hai',
    vietnamese:'Chị tôi tên lan Hoa, anh tôi tên là Hải',
    user_message:''
  },
  {
    id:6,
    english:'d. My grandfather is French, his name is Alain',
    vietnamese:'Ông tôi là người Pháp, ông ấy tên là Alain',
    user_message:''
  },
  
]

export const trans_2=[
  {
    id:1,
    english:'My sister is name is Sarah. She is American',
    vietnamese:'Chị gái tôi tên là Sarah. Chị ấy là người Mỹ',
    user_message:''
  },
  {
    id:2,
    english:'My grandmother is name is Lee. She is korean',
    vietnamese:'Bà nội em tên là Lee. Bà là người Hàn Quốc',
    user_message:''
  },
  {
    id:3,
    english:'Excuse me What is your name. What is your nationality?',
    vietnamese:'Xin Lỗi, bạn tên là gì. Bạn là người nước nào?',
    user_message:''
  },
  {
    id:4,
    english:'Hello. My name is Farid. I come from Malaysia. Nice to meet you',
    vietnamese:'Chào em. Tôi tên là farid. Tôi đến từ Malaysia. Rất vui được gặp em',
    user_message:''
  },
]